import React from 'react';
import { Box, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

interface TableSkeletonProps {
  columns?: number;
  rows?: number;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns = 5, rows = 6 }) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"><Skeleton variant="rectangular" width={18} height={18} /></TableCell>
        {Array.from({ length: columns }).map((_, i) => (
          <TableCell key={i}><Skeleton width={i === 0 ? 140 : 80} /></TableCell>
        ))}
        <TableCell align="right"><Skeleton width={60} sx={{ ml: 'auto' }} /></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {Array.from({ length: rows }).map((_, r) => (
        <TableRow key={r}>
          <TableCell padding="checkbox"><Skeleton variant="rectangular" width={18} height={18} /></TableCell>
          {Array.from({ length: columns }).map((_, c) => (
            <TableCell key={c}>
              {c === 0 ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Skeleton variant="circular" width={32} height={32} />
                  <Skeleton width={100} />
                </Box>
              ) : (
                <Skeleton width={c === columns - 1 ? 60 : 90} />
              )}
            </TableCell>
          ))}
          <TableCell align="right"><Skeleton width={50} sx={{ ml: 'auto' }} /></TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export const StatCardSkeleton: React.FC = () => (
  <Box sx={{ p: 2.5, borderRadius: 3, bgcolor: '#fff', border: '1px solid #e2e8f0' }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box sx={{ flex: 1 }}>
        <Skeleton width={80} height={14} sx={{ mb: 1.5 }} />
        <Skeleton width={60} height={36} sx={{ mb: 1 }} />
        <Skeleton width={50} height={14} />
      </Box>
      <Skeleton variant="rounded" width={48} height={48} sx={{ borderRadius: 2 }} />
    </Box>
  </Box>
);
